(function () {
  'use strict';
  var sheet;

  function money(cents) {
    var w = Math.floor(cents / 100), p = cents % 100;
    return '£' + w + (p ? '.' + String(p).padStart(2, '0') : '');
  }

  function buildSheet() {
    if (sheet) return sheet;
    sheet = document.createElement('div');
    sheet.className = 'tq-sheet';
    sheet.innerHTML =
      '<div class="tq-sheet__scrim" data-close></div>' +
      '<div class="tq-sheet__panel" role="dialog" aria-modal="true" aria-label="Added to bag">' +
        '<p class="tq-eyebrow" style="margin:0 0 14px">Added to your bag</p>' +
        '<div class="tq-sheet__row" data-row></div>' +
        '<div data-adds></div>' +
        '<div style="margin-top:22px;display:grid;gap:9px">' +
          '<a class="tq-btn" href="/checkout" data-checkout>Checkout</a>' +
          '<button type="button" class="tq-btn tq-btn--ghost" data-close>Keep looking</button>' +
        '</div>' +
      '</div>';
    document.body.appendChild(sheet);
    sheet.addEventListener('click', function (e) {
      if (e.target.hasAttribute('data-close')) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });
    return sheet;
  }

  function close() { if (sheet) sheet.classList.remove('is-on'); }

  function recommend(handle, cb) {
    fetch('/recommendations/products.json?product_id=' + handle + '&limit=3&intent=complementary')
      .then(function (r) { return r.json(); })
      .then(function (d) { cb(d.products || []); })
      .catch(function () { cb([]); });
  }

  function open(item, productId) {
    var s = buildSheet();
    var img = item.image ? item.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') : '';
    s.querySelector('[data-row]').innerHTML =
      (img ? '<img src="' + img + '" alt="">' : '<span></span>') +
      '<div>' +
        '<p class="tq-sheet__t">' + item.product_title + '</p>' +
        '<p class="tq-sheet__m">Size ' + item.variant_title + ' · ' + money(item.final_line_price) + '</p>' +
      '</div>';
    var adds = s.querySelector('[data-adds]');
    adds.innerHTML = '';
    recommend(productId, function (ps) {
      if (!ps.length) return;
      var html = '<p class="tq-eyebrow" style="margin:22px 0 0">Worn together</p><div class="tq-sheet__adds">';
      ps.forEach(function (p) {
        var pi = p.featured_image ? p.featured_image.replace(/(\.[a-z]+)(\?|$)/i, '_240x$1$2') : '';
        html += '<a class="tq-sheet__add" href="' + p.url + '">' +
          (pi ? '<img src="' + pi + '" alt="' + (p.title || '') + '">' : '<span></span>') +
          '<p>' + p.title + '<span>' + money(p.price) + '</span></p></a>';
      });
      adds.innerHTML = html + '</div>';
    });
    s.classList.add('is-on');
  }

  function add(btn) {
    var id = btn.getAttribute('data-variant');
    var pid = btn.getAttribute('data-product');
    btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        btn.disabled = false;
        var item = (d.items && d.items[0]) || d;
        if (!item || !item.product_title) { window.location = '/cart'; return; }
        open(item, pid);
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      })
      .catch(function () { btn.disabled = false; window.location = '/cart'; });
  }

  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-qa-open]');
    if (openBtn) {
      e.preventDefault();
      openBtn.closest('.tq-qa').classList.toggle('is-open');
      return;
    }
    var sizeBtn = e.target.closest('[data-variant]');
    if (sizeBtn) { e.preventDefault(); add(sizeBtn); }
  });
})();
